import { lightColorPalette } from '@linearb/linui-common';
import styled from 'styled-components';

export const StyledFilterSetWrapper = styled.div`
  position: relative;
  border: 1px solid ${lightColorPalette.lbBlue_20};
  border-radius: 5px;
`;

export const StyledFilterSetFilters = styled.main`
  padding: 0.5rem;
  &.isCollapsed {
    display: none;
  }
`;
